import { render, staticRenderFns } from "./UploadImgs.vue?vue&type=template&id=66663410&scoped=true"
import script from "./UploadImgs.vue?vue&type=script&lang=js"
export * from "./UploadImgs.vue?vue&type=script&lang=js"
import style0 from "./UploadImgs.vue?vue&type=style&index=0&id=66663410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66663410",
  null
  
)

export default component.exports